import { useState } from "react";
import { PromptsListModal } from "./PromptListModal";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const ManagePrompts = ({ type = "prompts" }) => {
  const [isListModalOpen, setIsListModalOpen] = useState(false);

  return (
    <>
      <button
        className="px-3 py-2 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors text-sm w-full"
        onClick={() => setIsListModalOpen(true)}
      >
        <FormattedMessage id="AGENTS.HOME.MANAGE" />
      </button>
      <PromptsListModal
        open={isListModalOpen}
        onClose={() => setIsListModalOpen(false)}
        type={type}
      />
    </>
  );
};

ManagePrompts.propTypes = {
  type: PropTypes.string.isRequired,
};

export { ManagePrompts };
